export const customerSearchDefaultOptions = [
  {
    key: "All",
    value: "All",
  },
  {
    key: "CompanyName",
    value: "Company Name",
  },
  {
    key: "Email",
    value: "Contact Email",
  },
  {
    key: "ContactName",
    value: "Contact Name",
  },
  {
    key: "ContactNumber",
    value: "Contact Number",
  },
];

// Customer Contact bulk upload model structure
export const customerContactModel = {
  userName: null,
  companyName: null,
  isDeleted: null,
  markupPercent: null,
  labourFee: null,
  travelFee: null,
  discountPercent: null,
  useGlobalMarkup: null,
  useGlobalLabour: null,
  useGlobalTravel: null,
  contactsCount: null,
  customerContacts: [
    {
      contactName: null,
      contactNumber: null,
      email: null,
    },
  ],
};
